export default "__VITE_ASSET__CmSd5ZfF__"